import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { ExceptionHandlingService } from 'src/app/shared/exception-handling.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
import * as moment from 'moment';

@Component({
  selector: 'mark-cancelled-modal',
  templateUrl: './mark-cancelled.component.html',
  styleUrls: ['./mark-cancelled.component.scss']
})
export class MarkCanceledModalComponent implements OnInit {

  @Input() selection: any;
  @Output() emitSuccess = new EventEmitter<any>();
  error: any = {}

  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    private errorService: ExceptionHandlingService,
    private toastr: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() { }

  datePickerOptions: IMyOptions = {
    dateFormat: 'mmm-dd-yyyy',
    closeAfterSelect: true,
    editableDateField: false
  };

  @ViewChild('cancelComponentsModal', { static: true }) cancelComponentsModal: any;

  action: any = {
    applyToMasterData:false
  };

  ngOnChanges() {
    if (this.selection && this.selection.id) {
      this.action = {};
      this.action.dateCanceled = moment(new Date()).format('MMM-DD-YYYY');
      this.getQueryComponents()
      this.cancelComponentsModal.show();
    }
  }

  confirmCancelComponents() {
    const url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/mark-canceled';
    const criticalComponentIds = [];
    this.components.map((comp) => {
      if (comp.isSelected)
        criticalComponentIds.push({ id: comp.id })
    })

    let modelSchema = {
      "dateCanceled": moment(new Date(this.action.dateCanceled)).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      "comments": this.action.comments ? this.action.comments : '',
      "applyToMasterData": this.action.applyToMasterData,
      "criticalComponentIds": criticalComponentIds
    }

    this.loader = true;
    this.service.put(url, {}, modelSchema).pipe(finalize(() => {
      this.loader = false;
    }))
      .subscribe(data => {
        this.cancelComponentsModal.hide();
        this.emitSuccess.emit()
        this.toastr.success(this.translate.instant('administration_componentsCanceledSuccessfully_label'), this.translate.instant('administration_confirmation_label'));
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        })
  }

  loader: boolean = false
  components: Array<any> = [];
  getQueryComponents() {
    this.components = [];
    this.loader = true;
    this.service.post(this.appConstants.endPoints.certificatesEndPoint + 'critical-components/query-components', {}, {
      "ids": this.selection.components,
      "isPaging": false
    })
      .pipe(finalize(() => {
        this.loader = false;
      }))
      .subscribe(data => {
        const components = data && data.searchResults ? data.searchResults : [];
        this.components = components.map(res => {
          if (res.quantityText * 1 != res.totalComponentsReceived) {
            res['isSelected'] = true;
            res['componentsReceived'] = (res.quantityText * 1);
          }
          return res
        })
      }, res => {
        this.errorService.errorHandling(res).then(res => {
          this.error = res;
        });
      });
  }


  checkedState() {
    let val = false;
    val = this.components.some(res=> res.isSelected == true)
    return val;
  }

  cancelReasons: any = [];
  cancelReasonsLoading: boolean = false;
  getCancelReasons() {
    this.cancelReasonsLoading = true;
    const url = this.appConstants.endPoints.certificatesEndPoint + 'options/component-cancel-reasons';
    this.service.post(url, {}, {
      "pageNumber": 1,
      "pageSize": 50,
      "isPaging": true,
      "status": true
    })
      .pipe(finalize(() => {
        this.cancelReasonsLoading = false;
      }))
      .subscribe(data => {
        this.cancelReasons = data && data.searchResults ? data.searchResults : [];
      }, error => {
        this.errorService.errorHandling(error).then(res => {
          this.error = res;
        });
      })
  }
}